import { render } from "./customRow.vue?vue&type=template&id=cdfe6c2e&scoped=true"
import script from "./customRow.vue?vue&type=script&lang=js"
export * from "./customRow.vue?vue&type=script&lang=js"

import "./customRow.vue?vue&type=style&index=0&id=cdfe6c2e&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cdfe6c2e"]])

export default __exports__